import { useContext } from "react";
import { AvisContext } from "../../../shared/context/AvisContext";

export function NotPortalReportMessage() {
  const { res } = useContext(AvisContext);

  return <div className="pt-5">{res("message_NoReportFromPortal")}</div>;
}
